import { CalloutType } from '../components/Callout';
const EVENT_NAME = 'toast';
const DISMISS_EVENT_NAME = 'toast-dismiss';
const DEFAULT_DURATION = 7000;
/** Show a toast notification.
 * @param message - The message to display in the toast
 * @param type - The type of toast (default: 'info')
 * @param options - Optional configuration for the toast
 * @returns The unique toast ID (useful for programmatic dismissal)
 */
export function toast(message, type = CalloutType.INFO, options) {
    const id = crypto.randomUUID();
    const detail = {
        id,
        message,
        type,
        target: options?.target ?? 'default',
        duration: options?.duration ?? DEFAULT_DURATION,
        icon: options?.icon ?? null,
        clearable: options?.clearable ?? true
    };
    document.dispatchEvent(new CustomEvent(EVENT_NAME, { detail }));
    return detail;
}
// Convenience shorthands with proper typing
toast.success = (msg, opts) => toast(msg, CalloutType.SUCCESS, opts);
toast.error = (msg, opts) => toast(msg, CalloutType.ERROR, opts);
toast.warning = (msg, opts) => toast(msg, CalloutType.WARNING, opts);
toast.info = (msg, opts) => toast(msg, CalloutType.INFO, opts);
/** Programmatically dismiss a toast by ID.
 * @param id - The unique toast ID to dismiss
 * @param target - Which toaster should receive the dismiss event (default: 'default')
 */
toast.dismiss = (id, target) => {
    const detail = { id, target: target ?? 'default' };
    document.dispatchEvent(new CustomEvent(DISMISS_EVENT_NAME, {
        detail
    }));
};
/**
 * Programmatically clear all toasts in a specific toaster.
 * @param target Which toaster should receive the clear event (default: 'default')
 */
toast.clear = (target) => {
    const detail = { id: '', target: target ?? 'default' };
    document.dispatchEvent(new CustomEvent(DISMISS_EVENT_NAME, {
        detail
    }));
};
/** The event name, exported so the toaster can reference it without magic strings. */
toast.EVENT_NAME = EVENT_NAME;
toast.DISMISS_EVENT_NAME = DISMISS_EVENT_NAME;
